import React from "react";
import { problemQuestions, problems } from "../data/landing";
import { Reveal, STAGGER } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
export function ProblemSection() {
  return <section aria-labelledby="problema" className="section-pad border-b border-line" data-id="element-326" data-mp="30hhcff6bi61b">
      <div className="page-container" data-id="element-327" data-mp="2vpzbus87i7gv">
        <div className="grid gap-8 md:gap-12 lg:grid-cols-12 lg:gap-8" data-id="element-328" data-mp="2vowmioqj8d32">
          <Reveal className="lg:col-span-7" data-id="element-329" data-mp="39h4f04as9hvy">
            <SectionHeader number="01" label="El problema" titleId="problema" title={<>
                  El dinero no se pierde en el anuncio.{" "}
                  <span className="text-gold" data-id="element-331" data-mp="3eh8ld1hz8w8g">Se pierde después de que el lead entra.</span>
                </>} data-id="element-330" data-mp="39jz0lz5j98qy" />
            <p className="body-copy mt-6" data-id="element-332" data-mp="1p33vku9zequs">
              Un lead te cuesta dinero.
              <span className="hidden md:inline" data-id="element-333" data-mp="1k3r8q9j41js7">
                {" "}
                Pero si nadie lo responde rápido, nadie insiste o nadie deja registro, ese
                dinero desaparece sin que el dueño lo vea.
              </span>
            </p>
          </Reveal>

          <Reveal delay={STAGGER} className="min-w-0 lg:col-span-4 lg:col-start-9 lg:self-end" data-id="element-334" data-mp="se1ube1raxdp">
            <ul className="hidden border-l border-gold/50 pl-6 md:block" data-id="element-335" data-mp="x49sx0pw93m8">
              {problemQuestions.map(q => <li key={q} className="py-1 text-[17px] text-muted" data-id="element-336" data-mp="124ebqxe9yafm">
                  {q}
                </li>)}
            </ul>
            <ul className="-mx-6 flex gap-2 overflow-x-auto px-6 pb-1 [scrollbar-width:none] md:hidden" data-id="element-337" data-mp="170v1tx51ayvc">
              {problemQuestions.map(q => <li key={q} className="shrink-0 whitespace-nowrap rounded-[3px] border border-line bg-surface px-3 py-2 text-[14px] text-muted" data-id="element-338" data-mp="1g3nqrtqquyi0">
                  {q}
                </li>)}
            </ul>
            <p className="mt-5 font-ui text-[17px] font-bold leading-snug text-cream md:mt-6 md:text-[18px]" data-id="element-339" data-mp="p0937xmc7khp">
              Si no tienes una respuesta clara, tienes una fuga.
            </p>
          </Reveal>
        </div>

        {/* Mobile: compact numbered list */}
        <ol className="mt-10 border-t border-line md:hidden" data-id="element-340" data-mp="y29xqmq6rsfo">
          {problems.map((item, i) => <li key={item.title} className="flex gap-4 border-b border-line py-5" data-id="element-341" data-mp="u1g9fs8u0bm9" data-mpi={i}>
              <span className="w-8 shrink-0 font-display text-[22px] leading-none text-gold" data-id="element-342" data-mp="17xk05bkhy1tz">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="min-w-0" data-id="element-343" data-mp="1hp7kytmjskmh">
                <h3 className="font-ui text-[17px] font-bold leading-snug text-cream" data-id="element-344" data-mp="1ho4ugmt50k73">{item.title}</h3>
                <p className="mt-1 line-clamp-2 text-[15px] leading-[1.5] text-muted" data-id="element-345" data-mp="1cqmsxhhg9794">{item.body}</p>
              </div>
            </li>)}
        </ol>

        <ol className="mt-12 hidden border-t border-line md:grid md:grid-cols-2 lg:grid-cols-4" data-id="element-346" data-mp="1lrb0pug92bdk">
          {problems.map((item, i) => <li key={item.title} className={`border-b border-line py-10 lg:border-b-0 lg:px-8 lg:first:pl-0 lg:last:pr-0 ${i > 0 ? "lg:border-l" : ""} ${i % 2 === 1 ? "md:border-l md:pl-8 lg:pl-8" : "md:pr-8"}`} data-id="element-347" data-mp="25d4irdjbfymy" data-mpi={i}>
              <Reveal delay={i * STAGGER} data-id="element-348" data-mp="20bngpep3i64s">
                <span className="font-display text-5xl leading-none text-gold" data-id="element-349" data-mp="1mm3k6qm3y53x">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="h3-item mt-10" data-id="element-350" data-mp="1re4q7usomzli">{item.title}</h3>
                <p className="body-copy mt-3" data-id="element-351" data-mp="1cofb0vnr8v28">{item.body}</p>
              </Reveal>
            </li>)}
        </ol>
      </div>
    </section>;
}